<template lang="pug">
v-container
  v-row
    v-col
        template(
          v-for="(item, idx) in Object.values(list)"
          v-if="item.value"
        )
          v-divider.mb-5.mt-4(
            v-if="idx !== 0"
            :key="`divider-${idx}`"
          )
          v-list-item(:key="`item-${idx}`")
            v-list-item-content
              v-list-item-title.text-body-1: strong.mr-12 {{ item.title }}
              .text-body-2 {{ item.value }}
</template>
<script>
export default {
  props: {
    organizationId: { type: Number, required: true },
  },
  data() {
    return {
      loading: true,
      list: {
        full_name: {
          title: 'Название организации',
          value: null,
        },
        legal_address: {
          title: 'Юридический адрес',
          value: null,
        },
        inn: {
          title: 'ИНН',
          value: null,
        },
        kpp: {
          title: 'КПП',
          value: null,
        },
        kbk: {
          title: 'КБК',
          value: null,
        },
        acc: {
          title: 'Расчетный счет',
          value: null,
        },
        okpo: {
          title: 'ОКПО',
          value: null,
        },
        ogrn: {
          title: 'ОГРН',
          value: null,
        },
        bank_name: {
          title: 'Банк',
          value: null,
        },
        bic: {
          title: 'БИК банка',
          value: null,
        },
        bank_cor_acc: {
          title: 'Корреспондентский счет банка',
          value: null,
        },
      },
    };
  },
  async created() {
    const { data } = await this.$api.dir.organizationShow(this.organizationId);
    const payment = data.data.payment_detail;
    Object.keys(this.list).forEach((key) => {
      this.list[key].value = key === 'full_name' ? data.data[key] : payment[key];
    });
    this.loading = false;
  },
};
</script>
